import { createSelector } from '@ngrx/store';

import { getVerificationStore } from '.';

export const getSummary = createSelector(
  getVerificationStore,
  ({ summary }) => summary,
);
